import type { PageProps } from 'gatsby';
import React from 'react';

import BigCircle from '@components/BigCircle';

import AdminManagement from '@views/Admin/Management';

export default function AdminPermissionDrilldownPage({ params }: PageProps) {
  const { id: permission_id } = params;

  return (
    <AdminManagement.Layout maxContentWidth="md">
      <BigCircle />
      <AdminManagement.Permissions.Drilldown permission_id={permission_id} />
    </AdminManagement.Layout>
  );
}
